import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { response } from '../common/interface';

@Injectable({
  providedIn: 'root'
})
export class SolicitorService {

  constructor(
    private http : HttpClient
  ) { }

  getSolicitors(advancePayment, status){
    let params : HttpParams = new HttpParams().set('advancePayment', advancePayment).set("active", status);
    return this.http.get<response>(environment.url + "solicitors", {params : params});
  }

  getSolicitor(id){
    let params: HttpParams = new HttpParams().set('id', id);
    return this.http.get<response>(environment.url + "solicitor", {params : params});
  }

  saveSolicitor(solicitor){
    return this.http.post<response>(environment.url + "solicitors", solicitor);
  }

  updateSolicitor(id, solicitor){
    return this.http.put<response>(environment.url + "solicitors/"+id, solicitor);
  }

  getSolicitorTeam(id){
    return this.http.get<response>(environment.url + "solicitor/teams/"+id);
  }

  updateSolicitorTeam(id, team){
    return this.http.put<response>(environment.url + "solicitor/teams/"+id, team);
  }

  saveSolicitorTeam(team){
    return this.http.post<response>(environment.url + "solicitors/teams", team);
  }

  deleteClient(id){
    return this.http.delete<response>(environment.url + "client/"+id);
  }

  generateReport(searchData){
    return this.http.post<response>(environment.url + "solicitors/search", searchData);
  }


}
